import React, { useState, useEffect } from 'react';

const EU_CODES = new Set([
  'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR',
  'DE','GR','HU','IE','IT','LV','LT','LU','MT','NL',
  'PL','PT','RO','SK','SI','ES','SE',
]);

export default function CookieBanner() {
  const [hidden, setHidden] = useState(
    () => !!localStorage.getItem('paydirt_cookies_accepted')
  );
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    if (hidden) return;
    fetch('https://ipapi.co/json/')
      .then(r => r.json())
      .then(data => {
        if (EU_CODES.has(data.country_code) || data.region === 'California') {
          setShouldShow(true);
        }
      })
      .catch(() => setShouldShow(true)); // safe default
  }, [hidden]);

  if (hidden || !shouldShow) return null;

  const accept = () => {
    localStorage.setItem('paydirt_cookies_accepted', 'true');
    setHidden(true);
  };

  const decline = () => {
    localStorage.setItem('paydirt_cookies_accepted', 'declined');
    setHidden(true);
  };

  return (
    <div style={{
      position: 'fixed', bottom: 64, left: 0, right: 0, zIndex: 150,
      background: '#111', borderTop: '1px solid #1a1a1a',
      padding: '14px 20px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      gap: 16, flexWrap: 'wrap',
    }}>
      <p style={{ color: '#9ca3af', fontSize: 12, lineHeight: 1.5, fontFamily: "'DM Sans', sans-serif", margin: 0, flex: 1, minWidth: 200 }}>
        We use cookies to keep you logged in and improve your experience. No tracking or advertising cookies.
      </p>
      <div style={{ display: 'flex', gap: 10, flexShrink: 0 }}>
        <button
          onClick={decline}
          style={{
            background: 'none', border: '1px solid #333', borderRadius: 6,
            color: '#9ca3af', fontSize: 12, padding: '7px 14px', cursor: 'pointer',
            fontFamily: "'DM Sans', sans-serif",
          }}
        >
          Decline
        </button>
        <button
          onClick={accept}
          style={{
            background: '#00e676', border: 'none', borderRadius: 6,
            color: '#000', fontWeight: 700, fontSize: 12, padding: '7px 18px',
            cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
          }}
        >
          Accept
        </button>
      </div>
    </div>
  );
}
